import { Filter } from "../../Models/Filter";
import FilterBadge from "../FilterBadge/FilterBadge";
import "./SuggestedFilters.css"

interface SuggestedFiltersProps {
    allFilters: Filter[];
    activeFilters: Filter[];
    onToggle: (filter: Filter) => void;
}

const SuggestedFilters: React.FC<SuggestedFiltersProps> = ({
    allFilters,
    activeFilters,
    onToggle
}) => {

    // Don't render anything if there are no suggested filters
    if (allFilters.length === 0) return null;
    return (
        <div id="Filter-Suggestions">
            {allFilters.map((filter) => (
                <FilterBadge
                    key={`${filter.filterType}:${filter.value}`}
                    filter={filter}
                    isActive={!!activeFilters.find(f => f.filterType === filter.filterType && f.value === filter.value)}
                    onToggle={onToggle}
                />
            ))}
        </div>
    )
}

export default SuggestedFilters;